<style lang="scss"></style>

<template>
  <div id="modal-estado" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form @submit.prevent="salvar">
          <div class="modal-header">
            <h4 class="modal-title">{{ id > 0 ? 'ALTERAR' : 'CADASTRAR' }} ESTADO</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-block shadow0 m0 pb0">
                  <div class="row form-group">
                    <div class="form-group m0 col-md-9" :class="{ 'has-error': $v.nome.$error }">
                      <label class="control-label">Nome</label>
                      <input
                        type="text"
                        class="form-control underlined"
                        v-model.trim="$v.nome.$model"
                      />
                      <template v-if="$v.nome.$dirty">
                        <span
                          v-if="!$v.nome.required"
                          class="has-error lblerror lblerror"
                        >Campo obrigatório</span>
                      </template>
                    </div>

                    <div class="form-group m0 col-md-3" :class="{ 'has-error': $v.uf.$error }">
                      <label class="control-label">UF</label>
                      <input
                        type="text"
                        class="form-control underlined"
                        maxlength="2"
                        v-model.trim="$v.uf.$model"
                      />
                      <template v-if="$v.uf.$dirty">
                        <span
                          v-if="!$v.uf.required"
                          class="has-error lblerror lblerror"
                        >Campo obrigatório</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="enviando"
            >{{ enviando ? "SALVANDO..." : "SALVAR" }}</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { showLoading, closeLoading } from '../../../helpers';
import EstadoService from '../../../services/EstadoService';

export default {
  name: 'modal-estado',
  data() {
    return {
      enviando: false,
      id: 0,
      nome: '',
      uf: '',
    };
  },
  validations: {
    nome: {
      required,
    },
    uf: {
      required,
    },
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-estado').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.estadoId = null;
    });

    if (this.$parent.estadoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.id = 0;
      this.nome = '';
      this.uf = '';
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.estadoId === 0) return;

        const estado = await EstadoService.findById(this.$parent.estadoId);

        this.id = estado.id;
        this.nome = estado.nome;
        this.uf = estado.uf;
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-estado').modal('show');
      }
    },
    async salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.enviando = true;

        showLoading();

        const estado = {
          id: this.id,
          nome: this.nome,
          uf: this.uf,
        };

        await EstadoService.save(estado);

        this.$toast.success('Estado salvo com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-estado').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
